import makeSlice from '@web/slices/merchants/sliceMaker'

const slice = makeSlice()

export default slice.reducer
